import noUndefined from "./lib/noUndefined";

const _URLS = Object.freeze({
  APPLICATIONS_ADMIN: "/api/v1/applications/admin/",
  APPLICATIONS_ADMIN_DETAIL: "/api/v1/applications/admin/:pk/",
  APPLICATIONS_ADMIN_OPEN_HOUSE: "/api/v1/applications/open-house/admin/",
  APPLICATIONS_ADMIN_OPEN_HOUSE_DETAIL: "/api/v1/applications/open-house/admin/:pk/",
  APPLICATIONS_ADMIN_REVIEW: "/api/v1/applications/admin/review/",
  APPLICATIONS_ADMIN_DECIDE: "/api/v1/applications/admin/decide/",
  APPLICATIONS_MEMBER: "/api/v1/applications/member/",
  APPLICATIONS_MEMBER_ACKNOWLEDGE_COMMITMENT: "/api/v1/applications/member/acknowledge_commitment/",
  APPLICATIONS_MEMBER_BATTERY_POWERED_MEMBERSHIP: "/api/v1/applications/member/battery_powered_membership/",
  APPLICATIONS_MEMBER_BATTERY_POWERED_VIDEO: "/api/v1/applications/member/battery_powered_video/",
  APPLICATIONS_MEMBER_CHOOSE_PASSWORD: "/api/v1/applications/member/choose_password/",
  APPLICATIONS_MEMBER_GYM: "/api/v1/applications/member/gym/",
  APPLICATIONS_MEMBER_APPLY_OPEN_HOUSE: "/api/v1/applications/member/open_house/",
  APPLICATIONS_MEMBER_OPEN_HOUSE: "/api/v1/applications/open-house/member/",
  APPLICATIONS_MEMBER_OPEN_HOUSE_RSVP: "/api/v1/applications/open-house-rsvp/",
  APPLICATIONS_MEMBER_PARTNER_MEMBERSHIP: "/api/v1/applications/member/partner_membership/",
  APPLICATIONS_MEMBER_PERSONAL_INFORMATION: "/api/v1/applications/member/personal_information/",
  APPLICATIONS_MEMBER_QUESTIONS: "/api/v1/applications/member/questions/",
  APPLICATIONS_MEMBER_REVIEW: "/api/v1/applications/member/review/",
  APPLICATIONS_MEMBER_SUBMIT: "/api/v1/applications/member/submit/",
  APPLICATIONS_MEMBER_UPLOAD_HEADSHOT: "/api/v1/applications/member/upload_headshot/",
  APPOINTMENTS_API_DATES_LIST: "/api/v1/appointments/dates/",
  APPOINTMENTS_API_LIST: "/api/v1/appointments/appointments/",
  APPOINTMENTS_API_OPTIN_ADMIN_LIST: "/api/v1/appointments/admin/optin/",
  APPOINTMENTS_API_SETTING: "/api/v1/appointments/setting/",
  FINANCE_API_BALANCE: "/api/finance/balance/",
  FINANCE_API_BALANCE_DETAILS: "/api/finance/balance/details/",
  FINANCE_API_MAIN_LEDGER: "/api/finance/main-ledger/",
  FINANCE_API_MAIN_LEDGER_ADJ: "/api/finance/main-ledger/:pk/adjust/",
  FINANCE_API_MAIN_LEDGER_POST_REVENUE: "/api/finance/main-ledger/:pk/post_revenue/",
  FINANCE_API_MAIN_LEDGER_REVENUE_CATEGORIES: "/api/finance/main-ledger/revenue_categories/",
  FINANCE_API_REFUND_REQUESTS: "/api/finance/refund-requests-read/",
  GROUP_DETAIL: "/api/v1/groups/:group_id/",
  GROUP_MEMBERS_ADMIN_API_DETAIL: "/api/v1/admin/groups/:group_id/members/:person_id/",
  GROUP_MEMBERS_ADMIN_API_LIST: "/api/v1/admin/groups/:group_id/members/",
  GROUP_MEMBERS_ADMIN_API_MODERATE: "/api/v1/admin/groups/:group_id/members/:person_id/moderate/",
  GROUP_MEMBERS_ADMIN_API_UNMODERATE: "/api/v1/admin/groups/:group_id/members/:person_id/unmoderate/",
  GROUP_MEMBERS_API_DETAIL: "/api/v1/groups/:group_id/members/:person_id/",
  GROUP_MEMBERS_API_LIST: "/api/v1/groups/:group_id/members/",
  GROUP_MEMBERS_DETAIL: "/admin/societies/:group_id/members/:person_id/",
  GROUP_MEMBERS_LIST: "/admin/societies/:group_id/members/",
  GROUP_PHOTOS_API_LIST: "/api/v1/groups/photos/",
  GROUP_PHOTOS_API_LIST_TO_REVIEW: "/api/v1/groups/photos/?approved_ind=false&image_ind=true",
  INTERVALS: "/api/v1/appointments/intervals/",
  MEMBERSHIP_CHANGES_LIST: "/api/v1/membership/changes/",
  MEMBERSHIP_CHANGES_ACCOUNT_LIST: "/api/v1/membership/changes/account/",
  MEMBERSHIP_CHANGES_OPTIONS_LIST: "/api/v1/membership/changes/options/",
  MEMBERSHIP_CHANGES_UPLOAD: "/api/v1/membership/changes/upload/",
  MEMBERSHIP_CHARGES_EXCLUDED_LIST: "/api/v1/membership/preview/charges/excluded/",
  MEMBERSHIP_CHARGES_MISMATCH_LIST: "/api/v1/membership/preview/charges/mismatch/",
  MEMBERSHIP_CHARGES_LIST: "/api/v1/membership/preview/charges/",
  OPTINS: "/api/v1/appointments/optin/",
  PASS_STATUS_API_DETAIL: "/api/v1/checkin/pass-status/:pk/",
  PEOPLE: "/api/people/search/",
  PERSON: "/api/v1/people/user/",
  PERSONAL_ASSISTANTS_API_DETAIL: "/api/v1/pa/:pk/",
  PERSONAL_ASSISTANTS_API_LIST: "/api/v1/pa/",
  RECIPROCITY: "/arrangements/inquire/",
  SEVENROOMS_API_ADMIN_RESERVATIONS: "/api/v1/sevenrooms/admin/reservations/",
  SEVENROOMS_API_ADMIN_RESERVATIONS_TODAY: "/api/v1/sevenrooms/admin/reservations/list_today/",
  SEVENROOMS_API_EVENT_BLOCKS: "/api/v1/sevenrooms/event-blocks/",
  SEVENROOMS_API_EVENT_BLOCKS_DETAIL: "/api/v1/sevenrooms/event-blocks/:pk/",
  SEVENROOMS_API_RESERVATIONS: "/api/v1/sevenrooms/reservations/",
  SEVENROOMS_API_RESERVATIONS_DETAIL: "/api/v1/sevenrooms/reservations/:pk/",
  SEVENROOMS_API_RESERVATION_REQUESTS: "/api/v1/sevenrooms/reservation-requests/",
  SEVENROOMS_API_VENUES: "/api/v1/sevenrooms/venues/",
  SEVENROOMS_API_VENUE_AVAILABILITY: "/api/v1/sevenrooms/venue-availability/",
  SLOTS: "/api/v1/appointments/slots/",
  SMS_ADMIN_SEND_SMS: "/admin/sms/send-ajax/",
  SMS_ADMIN_TEMPLATE_RENDER_SMS: "/admin/sms/templates/render",
  SMS_API_LIST: "/api/v1/sms/",
  SMS_API_TEMPLATE_LIST: "/api/v1/sms/templates/?ordering=name",
  VERIFY_REQUIRED_API: "/api/v1/verify/",
  VERIFY_REQUIRED_API_DETAIL: "/api/v1/verify/:pk/",
  VOTING_API_RATE: "/api/voting/rate/",
  VOTING_API_RATE_MY: "/api/voting/rate/my/",
  VOTING_API_RATE_OTHERS: "/api/voting/rate/others",
  VOTING_API_UPDATE_APPLICATIONS: "/api/voting/update/"
});

const URLS = noUndefined(_URLS);

export default URLS;
